import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {PickingListTranshipmentState} from "@/interfaces/state";
import {IdMapper} from "@/interfaces/state/base";
import {Lading, PickingListTranshipment} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import store from "@/store";
import { union } from "lodash";
import {PickingListTranshipmentParams} from "@/modules/pickinglisttranshipment/params";
import {
    confirmPickingListTranshipment,
    deletePickingListTranshipment,
    listBillLadingByPickingListTranshipmentCode,
    listBillLadingByPickingListTranshipmentId, listConfirmedPickingListTranshipment,
    listPickingListTranshipment,
    singlePickingListTranshipment
} from "@/modules/pickinglisttranshipment/services";
import {LadingStore} from "@/modules/ladings/store";
import {getDataSequentiallyV2} from "@/shared/services/helper/utils";

@Module({ dynamic: true, name: "pickingListTranshipment", store })
class PickingListTranshipmentModule extends VuexModule implements PickingListTranshipmentState {
    data: IdMapper<PickingListTranshipment> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: any = new PickingListTranshipmentParams();

    @Mutation
    private MAP_PICKING_LIST_TRANSHIPMENTS(payload: any) {
        const idMapper: IdMapper<PickingListTranshipment> = {};
        this.meta = payload.meta;
        this.ids = payload.datas.map((pickingList: PickingListTranshipment) => {
            idMapper[pickingList.id] = pickingList;
            return pickingList.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_PICKING_LIST_TRANSHIPMENT(payload: PickingListTranshipment) {
        if (!payload) return;
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = {
            ...this.data[payload.id] || {},
            ...payload
        };
    }

    @Mutation
    private UPDATE_PICKING_LIST_TRANSHIPMENT_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private SET_BILL_LADINGS_INTO_PICKING_LIST_TRANSHIPMENT({ id, billLadings }) {
        if (this.data[id]) {
            this.data[id] = { ...this.data[id], billLadings }
        }
        billLadings.forEach((billLading: Lading) => LadingStore.addLading(billLading));
    }

    @Mutation
    private REMOVE_PICKING_LIST_TRANSHIPMENT(payload: number) {
        this.ids.splice(this.ids.indexOf(payload), 1);
    }

    @Action({ rawError: true })
    public updatePickingListTranshipmentParams(payload: any) {
        this.UPDATE_PICKING_LIST_TRANSHIPMENT_PARAMS(payload);
    }

    @Action({ rawError: true })
    public async listPickingListTranshipment(payload: any) {
        const { data } = await listPickingListTranshipment(payload);
        this.MAP_PICKING_LIST_TRANSHIPMENTS(data);
    }

    @Action({ rawError: true })
    public async listConfirmedPickingListTranshipment(payload: any) {
        const { data } = await listConfirmedPickingListTranshipment(payload);
        this.MAP_PICKING_LIST_TRANSHIPMENTS(data);
    }

    @Action({ rawError: true })
    public async singlePickingListTranshipment(payload: any) {
        const { data } = await singlePickingListTranshipment(payload);
        this.SET_PICKING_LIST_TRANSHIPMENT(data.data);
    }

    @Action({ rawError: true })
    public async listBillLadingByPickingListTranshipment(payload: any) {
        const billLadings = await getDataSequentiallyV2(listBillLadingByPickingListTranshipmentId, { page: 1, limit: 50 }, payload);
        this.SET_BILL_LADINGS_INTO_PICKING_LIST_TRANSHIPMENT({ id: payload, billLadings: billLadings });
    }

    @Action({ rawError: true })
    public addPickingListTranshipment(payload: any) {
        this.SET_PICKING_LIST_TRANSHIPMENT(payload);
    }

    @Action({ rawError: true })
    public async deletePickingListTranshipment(payload: number) {
        await deletePickingListTranshipment(payload);
        this.REMOVE_PICKING_LIST_TRANSHIPMENT(payload);
    }

    @Action({ rawError: true })
    public async confirmPickingListTranshipment(payload: number) {
        const { data } = await confirmPickingListTranshipment(payload);
        this.SET_PICKING_LIST_TRANSHIPMENT(data.data);
    }
}

export const PickingListTranshipmentStore = getModule(PickingListTranshipmentModule);
